/* Product photos: thumbnails swap the main photo; tapping the main photo opens a full-screen viewer. */
(function () {
  var sets = document.querySelectorAll('[data-pm]');
  if (!sets.length) return;
  var v = document.createElement('div');
  v.className = 'pm-viewer'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', 'Photo viewer');
  v.innerHTML = '<div class="pmv-top"><span class="pmv-count" aria-live="polite"></span><button class="pmv-btn pmv-close" type="button" aria-label="Close">\u2715</button></div>' +
    '<div class="pmv-stage"><button class="pmv-btn pmv-prev" type="button" aria-label="Previous photo">\u2190</button>' +
    '<figure><img alt=""><figcaption></figcaption><div class="pmv-dots"></div></figure>' +
    '<button class="pmv-btn pmv-next" type="button" aria-label="Next photo">\u2192</button></div>';
  document.body.appendChild(v);
  var q = function (s) { return v.querySelector(s); };
  var img = q('img'), cap = q('figcaption'), count = q('.pmv-count'), dots = q('.pmv-dots');
  var prev = q('.pmv-prev'), next = q('.pmv-next'), closeBtn = q('.pmv-close'), stage = q('.pmv-stage');
  var cur = null, idx = 0, from = null, swiped = false, sx = null, sy = null;

  function render() {
    var p = cur[idx];
    img.src = p.full; img.alt = p.alt; cap.textContent = p.alt;
    count.textContent = (idx + 1) + ' / ' + cur.length;
    prev.disabled = idx === 0; next.disabled = idx === cur.length - 1;
    prev.hidden = next.hidden = cur.length < 2;
    dots.innerHTML = '';
    if (cur.length > 1) cur.forEach(function (_, j) {
      var b = document.createElement('button'); b.type = 'button';
      b.setAttribute('aria-label', 'Photo ' + (j + 1)); b.setAttribute('aria-current', j === idx ? 'true' : 'false');
      b.addEventListener('click', function () { idx = j; render(); });
      dots.appendChild(b);
    });
  }
  function open(set, i, btn) { cur = set; idx = i; from = btn; render(); v.classList.add('on'); document.documentElement.classList.add('pmv-open'); closeBtn.focus(); }
  function close() { v.classList.remove('on'); document.documentElement.classList.remove('pmv-open'); if (from) from.focus(); cur = null; }
  function go(d) { var n = idx + d; if (!cur || n < 0 || n >= cur.length) return; idx = n; render(); }

  closeBtn.addEventListener('click', close);
  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });
  stage.addEventListener('click', function (e) { if (swiped) { swiped = false; return; } if (e.target === stage) close(); });
  stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
  stage.addEventListener('pointerup', function (e) {
    if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { swiped = true; go(dx < 0 ? 1 : -1); setTimeout(function () { swiped = false; }, 0); }
  });
  document.addEventListener('keydown', function (e) {
    if (!v.classList.contains('on')) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(v.querySelectorAll('button:not([disabled])'), function (b) { return !b.hidden && b.offsetParent !== null; });
      if (!f.length) return; var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  }, true);

  Array.prototype.forEach.call(sets, function (pm) {
    var items = Array.prototype.map.call(pm.querySelectorAll('.pm-set li'), function (li) {
      return { full: li.getAttribute('data-full'), main: li.getAttribute('data-main'), alt: li.getAttribute('data-alt') };
    });
    var main = pm.querySelector('.pm-main'); if (!main || !items.length) return;
    var mimg = main.querySelector('img'), sel = 0;
    var thumbs = pm.querySelectorAll('.pm-thumbs button');
    function show(i) {
      sel = i; mimg.removeAttribute('srcset'); mimg.removeAttribute('sizes');
      mimg.src = items[i].main; mimg.alt = items[i].alt;
      main.setAttribute('aria-label', 'View larger: ' + items[i].alt);
      Array.prototype.forEach.call(thumbs, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    Array.prototype.forEach.call(thumbs, function (b, i) { b.addEventListener('click', function () { show(i); }); });
    main.addEventListener('click', function () { open(items, sel, main); });
  });
})();
